// --------------------------------------------------
// 通用版
// --------------------------------------------------
// 基本
import basic from '@/store/basicModel';
// 欢迎
import welcome from '@/pages/Welcome/model';
// 店铺
import shopPolymerManage from '@/pages/Business/Shop/Store/model';
import shopAgent from '@/pages/Shop/Agent/model';
// 企业
import shopAdvertisement from '@/pages/Shop/Advertisement/model';

// 业务 --- 商户
import shopBrand from '@/pages/Business/Shop/Brand/model';
import CompanyManage from '@/pages/Business/Company/Manage/model';
import shopLicense from '@/pages/Business/Shop/Qualifications/model';
import Allowance from '@/pages/Business/Company/Allowance/model';
import Complaint from '@/pages/Business/Shop/Complaint/model';

// 客户
import advice from '@/pages/Marketing/Advice/Advice/model';
import customerAccountDetail from '@/pages/Customer/CustomerAccount/CustomerAccountDetail/model';
import customerAbutment from '@/pages/Customer/Abutment/model';

import merchant from '@/pages/Merchant/Manage/model';
import merchantEnterprise from '@/pages/Customer/Enterprise/model';
// 营销
import marketingManage from '@/pages/Marketing/Manage/model';
import marketingPlatformCoupon from '@/pages/Marketing/PlatformCoupon/model';
import marketingLaunchManage from '@/pages/Marketing/LaunchManage/model';
import marketingNewWelfare from '@/pages/Marketing/NewWelfare/model';
import marketingTaskCenter from '@/pages/Marketing/TaskCenter/model';
import marketingLogistics from '@/pages/Marketing/Logistics/model';
import remindManage from '@/pages/Marketing/RecordManage/model';
import fullReductionManage from '@/pages/Marketing/FullReduction/model';
import redPacketManage from '@/pages/Marketing/RedPacketManage/model';
// 权限
import privilege from '@/pages/Privilege/Role/model';
import privilegeAccount from '@/pages/Privilege/AccountManage/model';
import BindMenu from '@/pages/Privilege/MenuBind/model';
import AuthPoint from '@/pages/Privilege/AuthPoint/model';
// 财务
import finance from '@/pages/Finance/model';
import advance from '@/pages/Finance/AdvanceFunds/modal';
import advanceForecast from '@/pages/Finance/AdvanceFundsForecast/modal';
import OfflineCost from '@/pages/Finance/OfflineCost/model';
// 数据

import dataTrade from '@/pages/Data/Trade/model';
import dataMarketing from '@/pages/Data/Marketing/model';
import dataOverview from '@/pages/Data/Overview/model';
import dataCustomergroup from '@/pages/Data/CustomerGroup/model';
import dataComment from '@/pages/Marketing/Advice/Comment/model';
import coreData from '@/pages/Data/CoreData/model';
// 设置
import settings from '@/pages/Settings/model';
// --------------------------------------------------
// 餐饮版 - 与通用版共存的页面 2018.10.12
// --------------------------------------------------
// 订单
// import foodOrderRefund from '@/pages/Order-food/Refund/model';
// 新增订单
import OptOrderList from '@/pages/OptOrder/List/model';
import OptOrderDetail from '@/pages/OptOrder/Detail/model';
import tsOrder from '@/pages/TsOrder/model';

// 设置
import BalanceManage from '@/pages/Settings/BalanceManage/model';
// 商圈管理
import OperationBussiness from '@/pages/Operation/Business/model';
import OperationNotice from '@/pages/Operation/Notice/model';
import OperationPickMeal from '@/pages/Operation/PickMeal/model';
// import BussinessMap from '@/pages/Operation/Business/Map/model';
import receptionist from '@/pages/Operation/Receptionist/model';
import orderRemindManage from '@/pages/Operation/OrderRemind/model';

// 物流
import gatherOrder from '@/pages/LogisticsManage/model';
import businessGroupManage from '@/pages/Operation/BusinessGroup/model';
import logisticsDispatch from '@/pages/LogisticsManage/LogisticsDispatch/model';
import logisticsRoute from '@/pages/LogisticsManage/LogisticsRoute/model';
import logisticsPath from '@/pages/LogisticsManage/LogisticsPath/model';
import logisticsAccrualType from '@/pages/LogisticsManage/LogisticsAccrualType/model';
import logisticsAccrualRule from '@/pages/LogisticsManage/LogisticsAccrualRule/model';
import schedule from '@/pages/LogisticsManage/Schedule/model';
import settleReport from '@/pages/LogisticsManage/Salary/SettleReport/model';
import salary from '@/pages/LogisticsManage/Salary/model';
// 账单
import billEnterprise from '@/pages/BillEnterprise/model';

// 团长管理
import ChiefList from '@/pages/Chief/ChiefList/model';
import ChiefCustomerManage from '@/pages/Chief/ChiefCustomerManage/model';
import ChiefActivityManage from '@/pages/Chief/ChiefActivityManage/model';
import ChiefBenefitManage from '@/pages/Chief/ChiefBenefitManage/model';

// 环保

import EnvironmentalRule from '@/pages/Environmental/model';

// 配置
import NoticeManage from '@/pages/Configure/MessageManage/Notice/model';

// -------------------------------------------------
// 餐饮版 - 只有餐饮版的页面 2019.2.15
// --------------------------------------------------

import bill from '@/pages/Bill/modal';

const models = {
  // --------------------------------------------------
  // 通用版
  // --------------------------------------------------
  // 基本
  basic,
  // 欢迎
  welcome,
  // 店铺
  shopPolymerManage,
  shopLicense,
  shopAgent,
  // 企业
  // enterprise,
  shopAdvertisement,
  // 业务 --- 商户
  shopBrand,
  // 业务 --- 企业
  CompanyManage,
  Allowance,
  Complaint,
  // 订单
  // orderList,
  // orderDetail,
  // orderRefund,
  // 新增订单逻辑
  OptOrderList,
  OptOrderDetail,
  tsOrder,
  // 客户
  advice,
  customerAbutment,
  customerAccountDetail,
  merchant,
  merchantEnterprise,
  // 营销
  marketingManage,
  marketingPlatformCoupon,
  marketingLaunchManage,
  marketingNewWelfare,
  marketingTaskCenter,
  marketingLogistics,
  remindManage,
  fullReductionManage,
  redPacketManage,
  // 权限
  privilege,
  privilegeAccount,
  BindMenu,
  AuthPoint,
  // 财务
  finance,
  advance,
  advanceForecast,
  OfflineCost,
  // 数据
  dataTrade,
  dataMarketing,
  dataOverview,
  dataComment,
  dataCustomergroup,
  coreData,
  // 设置
  settings,
  BalanceManage,
  OperationBussiness,
  // 营运
  // BussinessMap,
  OperationNotice,
  OperationPickMeal,
  receptionist,
  orderRemindManage,
  // 物流
  gatherOrder,
  logisticsDispatch,
  logisticsRoute,
  logisticsPath,
  businessGroupManage,
  logisticsAccrualType,
  logisticsAccrualRule,
  schedule,
  settleReport,
  salary,
  // 账单
  billEnterprise,
  bill,

  ChiefList,
  ChiefActivityManage,
  ChiefCustomerManage,
  ChiefBenefitManage,
  // 环保
  EnvironmentalRule,
  // 配置
  NoticeManage,
};

export default models;
